<button
  mat-menu-item
  [ngClass]="template.viewed ? null : 'pristine'"
  [routerLink]="template.routerLink || []"
  [queryParams]="{source: 'share'}"
>
  <h6>{{ template.name }}</h6>
  <p>Shared By: {{ template.owner }}</p>
</button>
